import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Wrench } from 'lucide-react';
import { RevisionesResumen } from '@/components/mantenimientos/RevisionesResumen';
import { ContratosResumen } from '@/components/mantenimientos/ContratosResumen';

const Mantenimientos: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Wrench className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Mantenimientos</h1>
          <p className="text-muted-foreground text-sm">
            Estado de las revisiones de los sistemas y situación de los contratos
          </p>
        </div>
      </div>

      <Tabs defaultValue="revisiones" className="space-y-4">
        <TabsList>
          <TabsTrigger value="revisiones">Revisiones</TabsTrigger>
          <TabsTrigger value="contratos">Contratos</TabsTrigger>
        </TabsList>
        <TabsContent value="revisiones">
          <RevisionesResumen />
        </TabsContent>
        <TabsContent value="contratos">
          <ContratosResumen />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Mantenimientos;
